var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('veui-field',_vm._b({ref:"field",class:( _obj = {}, _obj[_vm.$c('fieldset')] = true, _obj[_vm.$c('field-required')] = _vm.required, _obj ),attrs:{"ui":_vm.realUi,"role":"group","required":_vm.required}},'veui-field',_vm.$attrs,false),[_c('template',{slot:"label"},[_vm._t("label")],2),_vm._t("default"),_c('template',{slot:"tip"},[_vm._t("tip")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }